(() => {
  // Back/forward cache must not restore a selector alongside stale price or buy controls.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });
  // Delegation also works when Shopify reloads a section in the theme editor.
  const closeMenu = (restoreFocus = false) => {
    const toggle = document.querySelector('.menu-toggle');
    toggle?.setAttribute('aria-expanded', 'false');
    if (toggle) toggle.textContent = 'Menú';
    document.querySelector('#SiteNav')?.classList.remove('is-open');
    if (restoreFocus) toggle?.focus();
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.menu-toggle');
    if (toggle) {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Cerrar' : 'Menú';
      document.querySelector('#SiteNav')?.classList.toggle('is-open', open);
      return;
    }
    if (event.target.closest('#SiteNav a, #SiteNav button') || !event.target.closest('.site-header')) closeMenu();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.querySelector('.menu-toggle')?.getAttribute('aria-expanded') === 'true') closeMenu(true);
  });
  document.addEventListener('change', (event) => {
    const control = event.target;
    if (control.matches('[data-sort-by]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', control.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
    if (control.matches('[data-variant-select]')) {
      // Native Shopify rendering keeps price, availability and payment buttons in sync.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', control.value);
      url.searchParams.delete('option_values');
      const product = control.closest('[data-product-section]');
      product?.querySelector('[data-add-to-cart]')?.setAttribute('disabled', 'disabled');
      const payment = product?.querySelector('[data-dynamic-checkout]');
      if (payment) payment.hidden = true;
      const status = product?.querySelector('[data-variant-status]');
      if (status) status.textContent = 'Actualizando presentación…';
      window.location.assign(url.toString());
    }
  });
})();
